import { workingDraftStorage } from './workingDraftStorage';
import { z } from 'zod';
import { STUDY_TOOL_CACHE_PREFIX } from '@/auth/studyToolCache';
import { MAX_CANVAS_BYTES, workingContentSchema } from './workingCanvas';

export function listDeviceWorkingDrafts(kidId: string | null | undefined) {
  if (!kidId) return [];
  const prefix = `${STUDY_TOOL_CACHE_PREFIX}working:${kidId}:`;
  const drafts: Array<{ questionId: string; pageId?: string; question: string; synced: boolean }> =
    [];
  try {
    for (let index = 0; index < workingDraftStorage().length; index += 1) {
      const key = workingDraftStorage().key(index);
      if (!key?.startsWith(prefix)) continue;
      try {
        const context = z
          .object({ kind: z.literal('free'), question_id: z.string().uuid() })
          .strict()
          .safeParse(JSON.parse(key.slice(prefix.length)));
        const raw = workingDraftStorage().getItem(key);
        if (!context.success || !raw || raw.length > MAX_CANVAS_BYTES + 10000) continue;
        const draft = z
          .object({
            id: z.string().uuid().optional(),
            content: workingContentSchema,
            version: z.number().int().nonnegative(),
            dirty: z.boolean(),
          })
          .safeParse(JSON.parse(raw));
        if (!draft.success || (draft.data.version > 0 && !draft.data.dirty)) continue;
        const content = draft.data.content;
        if (
          !draft.data.dirty &&
          !content.question?.trim() &&
          !content.text.trim() &&
          !content.strokes.length
        )
          continue;
        drafts.push({
          questionId: context.data.question_id,
          ...(draft.data.id ? { pageId: draft.data.id } : {}),
          question: draft.data.content.question?.trim().slice(0, 160) || 'My question',
          synced: draft.data.version > 0,
        });
      } catch {
        continue;
      }
    }
  } catch {
    /* Storage is optional; cloud pages remain available. */
  }
  return drafts;
}
